import { render, staticRenderFns } from "./space.vue?vue&type=template&id=1f430bf0&scoped=true&lang=pug&"
import script from "./space.vue?vue&type=script&lang=js&"
export * from "./space.vue?vue&type=script&lang=js&"
import style0 from "./space.vue?vue&type=style&index=0&id=1f430bf0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f430bf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1f430bf0', component.options)
    } else {
      api.reload('1f430bf0', component.options)
    }
    module.hot.accept("./space.vue?vue&type=template&id=1f430bf0&scoped=true&lang=pug&", function () {
      api.rerender('1f430bf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/space.vue"
export default component.exports